import {PageManager} from 'genesis-packages/core';
import './MULTI_SYSTEM.scss';
import 'extensions/multi-system';

export default class MULTI_SYSTEM extends PageManager {

	constructor (pageContext) {
		super(pageContext);
	}
};
